import { motion, useReducedMotion } from "framer-motion";

export const FadeUp = ({ children, delay = 0, className = "", y = 28, ...rest }) => {
  const reduced = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: reduced ? 0 : y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "0px 0px -8% 0px" }}
      transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => {
  const reduced = useReducedMotion();
  return (
    <motion.span
      className={`block overflow-hidden ${className}`}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "0px 0px -8% 0px" }}
    >
      <motion.span
        className="block"
        variants={{
          hidden: { y: reduced ? 0 : "112%" },
          show: { y: 0, transition: { duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] } },
        }}
      >
        {children}
      </motion.span>
    </motion.span>
  );
};

export const GoldDot = ({ className = "" }) => (
  <span
    className={`inline-block h-[6px] w-[6px] rounded-full bg-gold ${className}`}
    aria-hidden="true"
  />
);

export const LineToDot = ({ className = "", delay = 0 }) => {
  const reduced = useReducedMotion();
  return (
    <span className={`flex items-center gap-0 ${className}`} aria-hidden="true">
      <motion.span
        className="block h-px flex-1 origin-left rounded-full bg-gold/70"
        initial={{ scaleX: reduced ? 1 : 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true, margin: "0px 0px -8% 0px" }}
        transition={{ duration: 1, delay, ease: [0.22, 1, 0.36, 1] }}
      />
      <motion.span
        className="block h-[6px] w-[6px] shrink-0 rounded-full bg-gold"
        initial={{ scale: 0, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 1 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.6, delay: delay + (reduced ? 0 : 1.1), ease: "easeOut" }}
      />
    </span>
  );
};
